cv.TeamDetailsView = Marionette.LayoutView.extend({
  className: '',

  template : cv.Templates['team/edit'],

  behaviors : [{
    behaviorClass : cv.FormBehavior
  }],

  regions : {
    custom_fields : '#custom-fields'
  },

  events : {
  },

  validation: {
    photo_path: [],
    name: [{
      required: 'true',
      msg: "Required"
    }],
    stub: [{
      required: 'true',
      msg: "Invalid URL"
    },{
      valid_team_stub : true
    }],
    funds_needed: [{
      min: 0,
      msg: "Invalid amount"
    }]
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this, 'form:saved', function(){
      // Refresh the parent UI
      vent.trigger('team:refresh');

      // Rewrite the URL
      history.pushState(null, '', '/team/' + this.model.get('stub') + '/admin/page/details');

      // Refresh the router
      cv.teamAdminRouter = new cv.TeamAdminRouter('team/' + this.model.get('stub') + '/admin', {
        team_model : this.model
      });
    }, this);
    
    console.log('TeamDetailsView initialized');
  },

  templateHelpers: function(){
    return {
      team_photo_upload : cv.Templates['global/form/form_upload_profile']({
        label : 'Team Photo',
        id : 'photo_path',
        photo_default : cv.campaign.get('default_team_photo')
      }),
      enable_team_funds_needed : cv.campaign.get('enable_team_funds_needed') == 1 ? true : false,
      currency_code : cv.campaign.get('currency_code')
    }
  },

  onAttach: function(){
    var customFieldsView = new cv.CustomFieldsFormView({
      values : this.model.get('custom_values'),
      type : 'team',
      container : this.$('#additional-info')
    });

    // Bind a listener
    this.listenTo(customFieldsView, 'form:saved', function(view){
      this.trigger('form:set', 'custom_values', view.getValues());
    }, this);

    // Link the custom form
    this.trigger('form:link', customFieldsView);
    this.showChildView('custom_fields', customFieldsView);
  },

  onDestroy: function(){
  }
});
